<div class="block-highlight" style="background-color: {{backgroundColor}}; color: {{textColor}}">
    <div class="block-highlight__icon">
        <i style="color: {{iconColor}}" class="fa {{icon}}"></i>
    </div>
    <div class="block-highlight__content" [innerHTML]="content" appLinkHandler></div>
</div>
